import React from 'react';

import {StdBox, TextBT} from './styles';

const Button = ({text, handle, minWid = '44px'}) => {
  return (
    <>
      <StdBox
      onClick={handle}
      $minWid={minWid}
      >
        <TextBT>{text}</TextBT>
      </StdBox>
    </>
  );
};
export default Button;
